import { HttpStatusCode } from 'axios';
import { API } from '../config/config';
import axios from 'axios';
import buildResponse from './helpers';

const normalizeCashRegisterDetail = (detail = {}) => ({
  initial_mount: detail.initial_mount ?? 0,
  cash_sale_total: detail.cash_sale_total ?? 0,
  trans_sale_total: detail.trans_sale_total ?? 0,
  total_income: detail.total_income ?? 0,
  total_expenses: detail.total_expenses ?? 0,
  final_cash_amount: detail.final_cash_amount ?? 0,
  expected_cash_amount: detail.expected_cash_amount ?? 0,
  difference: detail.difference ?? 0,
  total_deposits: detail.total_deposits ?? 0,
  total_refunds: detail.total_refunds ?? 0,
});

const normalizeCashRegister = (cashRegister) => {
  const resolvedCashRegister = Array.isArray(cashRegister)
    ? cashRegister[0]
    : cashRegister?.cash_register || cashRegister?.cashRegister || cashRegister;

  if (!resolvedCashRegister) {
    return null;
  }

  return {
    ...resolvedCashRegister,
    detail_cash_register: normalizeCashRegisterDetail(resolvedCashRegister.detail_cash_register),
  };
};

const SaleService = {
  save: (storeId, data) => saveSale(storeId, data),
  getAll: (storeId, status, date) => getAll(storeId, status, date),
  searchSales: (storeId, query) => searchSales(storeId, query),
  updateStatus: (storeId, status, sales) => updateStatus(storeId, status, sales),
  updateName: (storeId, saleId, nameSale) => updateName(storeId, saleId, nameSale),
  returnSale: (sale) => returnSale(sale),
  addDeposit: (storeId, nameSale, amount) => addDeposit(storeId, nameSale, amount),
  assignRaffle: (storeId, data) => assignRaffle(storeId, data),
  updateHeld: (storeId, data) => updateHeld(storeId, data),
  getCurrentCashRegister: (storeId) => getCurrentCashRegister(storeId),
  createCashRegister: (cashRegister) => createCashRegister(cashRegister),
  saveCashRegister: (cashRegister) => saveCashRegister(cashRegister)
};

const assignRaffle = async (storeId, { nameSale, numero_rifa, lote_rifa, dni, telefono }) => {
  try {
    const response = await API.patch(`/stores/${storeId}/sales/raffle`, { nameSale, numero_rifa, lote_rifa, dni, telefono });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

const updateHeld = async (storeId, { idSale, held }) => {
  try {
    const response = await API.patch(`/stores/${storeId}/sales/held`, { idSale, held });
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err;
  }
};

const addDeposit = async (storeId, nameSale, amount) => {
  try {
    const response = await API.patch(`/stores/${storeId}/sales/deposit`, { nameSale, amount })
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const updateName = async (storeId, saleId, nameSale) => {
  try {
    const response = await API.patch(`/stores/${storeId}/sales/${saleId}`, { nameSale })
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const saveCashRegister = async (cashRegister) => {
  try {
    const response = await API.post(`/stores/${cashRegister.store_id}/cashregister/update`, cashRegister);
    return normalizeCashRegister(response.data);
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const createCashRegister = async (cashRegister) => {
  try {
    const response = await API.post(`/stores/${cashRegister.store_id}/cashregister`, cashRegister);
    return normalizeCashRegister(response.data);
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const getCurrentCashRegister = async (storeId) => {
  try {
    const response = await API.get(`/stores/${storeId}/cashregister`);
    return normalizeCashRegister(response.data);
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const returnSale = async (sale) => {
  try {
    var response = await API.post(`/stores/${sale.store_id}/updateStock/return`, sale)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const updateStatus = async (storeId, status, sales) => {
  try {
    var response = await API.post(`/stores/${storeId}/sales/changestatus?status=${status}`, sales)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const getAll = async (storeId, status = [], date) => {
  try {
    const query = new URLSearchParams();

    status.forEach(s => query.append("status", s)); // Agrega todos los status (si hay)
    query.append("date", date); // Siempre agrega la fecha

    const response = await API.get(`/stores/${storeId}/sales?${query.toString()}`);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const saveSale = async (storeId, data) => {
  try {
    var response = await API.post(`/stores/${storeId}/sales`, data)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw err
  }
}

const searchSales = async (storeId, query) => {
  try {
    var response = await API.get(`/stores/${storeId}/sales?` + query)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

export default SaleService;
